const kenyaCounties = {
    "Mombasa": [
      "Changamwe",
      "Jomvu",
      "Kisauni",
      "Nyali",
      "Likoni",
      "Mvita"
    ],
  
    "Kwale": [
      "Matuga",
      "Kinango",
      "Lunga Lunga",
      "Msambweni"
    ],
  
    "Kilifi": [
      "Kilifi North",
      "Kilifi South",
      "Kaloleni",
      "Rabai",
      "Ganze",
      "Malindi",
      "Magarini"
    ],
  
    "Tana River": [
      "Galole",
      "Garsen",
      "Bura"
    ],
  
    "Lamu": [
      "Lamu East",
      "Lamu West"
    ],
  
    "Taita-Taveta": [
      "Taveta",
      "Wundanyi",
      "Mwatate",
      "Voi"
    ],
  
    "Garissa": [
      "Garissa Township",
      "Balambala",
      "Lagdera",
      "Dadaab",
      "Fafi",
      "Ijara"
    ],
  
    "Wajir": [
      "Wajir East",
      "Wajir North",
      "Tarbaj",
      "Wajir South",
      "Eldas",
      "Wajir West"
    ],
  
    "Mandera": [
      "Mandera East",
      "Mandera North",
      "Mandera South",
      "Mandera West",
      "Banissa",
      "Lafey"
    ],
  
    "Marsabit": [
      "Laisamis",
      "Moyale",
      "North Horr",
      "Saku"
    ],
  
    "Isiolo": [
      "Isiolo North",
      "Isiolo South"
    ],
  
    "Meru": [
      "Buuri",
      "Central Imenti",
      "Igembe Central",
      "Igembe North",
      "Igembe South",
      "North Imenti",
      "South Imenti",
      "Tigania East",
      "Tigania West"
    ],
  
    "Tharaka-Nithi": [
      "Chuka/Igambang’ombe",
      "Maara",
      "Tharaka"
    ],
  
    "Embu": [
      "Manyatta",
      "Mbeere North",
      "Mbeere South",
      "Runyenjes"
    ],
  
    "Kitui": [
      "Kitui Central",
      "Kitui East",
      "Kitui Rural",
      "Kitui South",
      "Kitui West",
      "Mwingi Central",
      "Mwingi North",
      "Mwingi West"
    ],
  
    "Machakos": [
      "Kangundo",
      "Kathiani",
      "Machakos Town",
      "Masinga",
      "Matungulu",
      "Mavoko",
      "Mwala",
      "Yatta"
    ],
  
    "Makueni": [
      "Kaiti",
      "Kibwezi East",
      "Kibwezi West",
      "Kilome",
      "Makueni",
      "Mbooni"
    ],
  
    "Nyandarua": [
      "Kinangop",
      "Kipipiri",
      "Ndaragwa",
      "Ol Joro Orok",
      "Ol Kalou"
    ],
  
    "Nyeri": [
      "Kieni",
      "Mathira",
      "Mukurweini",
      "Nyeri Town",
      "Othaya",
      "Tetu"
    ],
  
    "Kirinyaga": [
      "Gichugu",
      "Kirinyaga Central",
      "Mwea",
      "Ndia"
    ],
  
    "Murang’a": [
      "Gatanga",
      "Kandara",
      "Kangema",
      "Kigumo",
      "Kiharu",
      "Maragua",
      "Mathioya"
    ],
  
    "Kiambu": [
      "Gatundu North",
      "Gatundu South",
      "Githunguri",
      "Juja",
      "Kabete",
      "Kiambaa",
      "Kiambu Town",
      "Kikuyu",
      "Lari",
      "Limuru",
      "Ruiru",
      "Thika Town"
    ],
  
    "Turkana": [
      "Turkana Central",
      "Turkana East",
      "Turkana North",
      "Turkana South",
      "Turkana West",
      "Loima"
    ],
  
    "West Pokot": [
      "Kacheliba",
      "Kapenguria",
      "Pokot South",
      "Sigor"
    ],
  
    "Samburu": [
      "Samburu East",
      "Samburu North",
      "Samburu West"
    ],
  
    "Trans Nzoia": [
      "Cherangany",
      "Endebess",
      "Kiminini",
      "Kwanza",
      "Saboti"
    ],
  
    "Uasin Gishu": [
      "Ainabkoi",
      "Kapseret",
      "Kesses",
      "Moiben",
      "Soy",
      "Turbo"
    ],
  
    "Elgeyo-Marakwet": [
      "Keiyo North",
      "Keiyo South",
      "Marakwet East",
      "Marakwet West"
    ],
  
    "Nandi": [
      "Aldai",
      "Chesumei",
      "Emgwen",
      "Mosop",
      "Nandi Hills",
      "Tinderet"
    ],
  
    "Baringo": [
      "Baringo East",
      "Baringo West",
      "Baringo Central",
      "Eldama Ravine",
      "Mogotio",
      "Tiaty"
    ],
  
    "Laikipia": [
      "Laikipia East",
      "Laikipia North",
      "Laikipia West"
    ],
  
    "Nakuru": [
      "Bahati",
      "Kuresoi North",
      "Kuresoi South",
      "Molo",
      "Naivasha",
      "Njoro",
      "Nakuru East",
      "Nakuru West",
      "Subukia",
      "Rongai",
      "Gilgil"
    ],
  
    "Narok": [
      "Narok East",
      "Narok North",
      "Narok South",
      "Narok West",
      "Emurua Dikirr",
      "Kilgoris"
    ],
  
    "Kajiado": [
      "Kajiado Central",
      "Kajiado North",
      "Kajiado South",
      "Kajiado East",
      "Kajiado West"
    ],
  
    "Kericho": [
      "Ainamoi",
      "Belgut",
      "Bureti",
      "Kipkelion East",
      "Kipkelion West",
      "Sigowet-Soin"
    ],
  
    "Bomet": [
      "Bomet Central",
      "Bomet East",
      "Chepalungu",
      "Konoin",
      "Sotik"
    ],
  
    "Kakamega": [
      "Lugari",
      "Likuyani",
      "Malava",
      "Lurambi",
      "Navakholo",
      "Mumias West",
      "Mumias East",
      "Matungu",
      "Butere",
      "Khwisero",
      "Shinyalu",
      "Ikolomani"
    ],
  
    "Vihiga": [
      "Emuhaya",
      "Luanda",
      "Vihiga",
      "Sabatia",
      "Hamisi"
    ],
  
    "Bungoma": [
      "Kabuchai",
      "Kanduyi",
      "Sirisia",
      "Kimilili",
      "Bumula",
      "Tongaren",
      "Webuye East",
      "Webuye West",
      "Mt. Elgon"
    ],
  
    "Busia": [
      "Budalangi",
      "Butula",
      "Funyula",
      "Nambale",
      "Matayos",
      "Teso North",
      "Teso South"
    ],
  
    "Siaya": [
      "Alego-Usonga",
      "Bondo",
      "Gem",
      "Rarieda",
      "Ugenya",
      "Ugunja"
    ],
  
    "Kisumu": [
      "Kisumu East",
      "Kisumu West",
      "Kisumu Central",
      "Seme",
      "Nyando",
      "Muhoroni",
      "Nyakach"
    ],
  
    "Homa Bay": [
      "Homa Bay Town",
      "Kabondo-Kasipul",
      "Karachuonyo",
      "Rangwe",
      "Ndhiwa",
      "Mbita",
      "Suba",
      "Gwasi"
    ],
  
    "Migori": [
      "Suna East",
      "Suna West",
      "Nyatike",
      "Kuria East",
      "Kuria West",
      "Uriri",
      "Rongo",
      "Awendo"
    ],
  
    "Kisii": [
      "Kisii Central",
      "Kisii South",
      "Nyaribari Chache",
      "Nyaribari Masaba",
      "Kitutu Chache",
      "Kitutu Masaba",
      "Bomachoge Borabu",
      "Bomachoge Chache",
      "South Mugirango",
      "Gucha"
    ],
  
    "Nyamira": [
      "West Mugirango",
      "Kitutu Chache North",
      "North Mugirango",
      "Borabu"
    ],
  
    "Nairobi": [
      "Westlands",
      "Dagoretti North",
      "Dagoretti South",
      "Lang’ata",
      "Kibra",
      "Roysambu",
      "Kasarani",
      "Ruaraka",
      "Embakasi South",
      "Embakasi North",
      "Embakasi Central",
      "Embakasi East",
      "Embakasi West",
      "Makadara",
      "Kamukunji",
      "Starehe",
      "Mathare"
    ]
  };
  
export { kenyaCounties };